
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';



function SidebarItems({ item }) {
  const location = useLocation();
  const currentPath = location.pathname.split('/')[1];
  const fullPath = location.pathname;

  // Add "s" or "es" to the current path as needed
  const modifiedPath = currentPath + 's';
  const modifiedPathEs = currentPath + 'es';
  const modifiedPaths = currentPath.replace('detail', '');

  return (
    <>
      <li className={`nav-item side-nav-item ${currentPath === item.type || modifiedPath === item.type || modifiedPaths === item.type || modifiedPathEs === item.type ? 'active' : ''}`}>
        <Link
          className='nav-link'
          to={item.link}
          title={item.title}
          onClick={item.link === `/${fullPath}` ? () => window.location.reload() : undefined} // Reload only if the full path matches
        >
          <span className="material-symbols-outlined">{item.icon}</span>
          <p>{item.title}</p>
        </Link>
      </li>
    </>
  );
}


export default SidebarItems;
